import { type MCPServerInfo } from '../../types';

const SmartbearServer: MCPServerInfo = {
  serverId: 'SMARTBEAR',
  name: 'SmartBear',
  slug: 'smartbear',
  description:
    'SmartBear MCP Server for API Hub, Test Hub, BugSnag, QMetry, and other SmartBear tools',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/smartbear:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@smartbear/mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      apiHubApiKey: {
        type: 'string',
        description: 'API Hub Portal API key from app.swaggerhub.com',
        sensitive: true
      },
      bugsnagAuthToken: {
        type: 'string',
        description: 'BugSnag authentication token from app.bugsnag.com',
        sensitive: true
      },
      bugsnagProjectApiKey: {
        type: 'string',
        description:
          'BugSnag project API key (optional, for scoping to a single project)',
        sensitive: true
      },
      pactBrokerBaseUrl: {
        type: 'string',
        description: 'PactFlow/Pact Broker base URL',
        sensitive: false
      },
      pactBrokerPassword: {
        type: 'string',
        description: 'PactFlow/Pact Broker password (alternative to token)',
        sensitive: true
      },
      pactBrokerToken: {
        type: 'string',
        description: 'PactFlow/Pact Broker API token',
        sensitive: true
      },
      pactBrokerUsername: {
        type: 'string',
        description: 'PactFlow/Pact Broker username (alternative to token)',
        sensitive: false
      },
      qmetryApiKey: {
        type: 'string',
        description: 'QMetry API key from app.qmetry.com',
        sensitive: true
      },
      qmetryBaseUrl: {
        type: 'string',
        description: 'QMetry base URL',
        sensitive: false
      },
      reflectApiToken: {
        type: 'string',
        description: 'Test Hub (Reflect) API token from app.reflect.run',
        sensitive: true
      },
      zephyrApiToken: {
        type: 'string',
        description: 'Zephyr API token from app.zephyrscale.io',
        sensitive: true
      },
      zephyrBaseUrl: {
        type: 'string',
        description:
          'Zephyr base URL (defaults to https://api.zephyrscale.smartbear.com/v2)',
        sensitive: false
      }
    }
  }
};

export default SmartbearServer;
